import { IGroup } from 'src/interfaces/group';
import { getDocumentId } from 'src/utils/mongo/getDocumentId';

/**
 * Extracts the IDs of groups from an array of group objects.
 *
 * @param groups - An array of group objects.
 * @returns An array of group IDs.
 */
export const extractGroupsIds = (groups: (IGroup | string)[]): string[] => {
    let result: string[] = [];
    if (!groups || groups.length === 0) return result;
    groups.map((item) => {
        const id = getDocumentId(item);
        if (id) result.push(id);
    });
    return result;
};
